import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  from: string;
  to: string;
}

export const RedirectClientAppPath = ({ to, from }: Props): null => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const newPath = location.pathname.replace(from, to);
    navigate(newPath + location.search, { replace: true });
  }, [location, navigate]);

  return null;
};
